<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>

      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Tanımlı Hesaplar" prop="Banka_id">
                <el-select v-model="Form.Banka_id" filterable clearable>
                  <el-option
                    v-for="item in BankaListe"
                    :key="item.id"
                    :label="item.Tanim"
                    :value="item.id">
                    <span style="float: left">{{ item.Tanim }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.Banka }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Hareket Türü" prop="Tur">
                <el-select v-model="Form.Tur" filterable>
                  <el-option
                    label="Tümü"
                    value="0">
                  </el-option>
                  <el-option
                    label="Gelen"
                    value="1">
                  </el-option>
                  <el-option
                    label="Giden"
                    value="2">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="9">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            class="table-xs "

            :data="tableData"
            style="width: 100%"
            width="100%"
            show-summary
            :height="Height"
            :summary-method="TableFooter"
          >
            <el-table-column
              label="Banka"
              prop="Banka"
              width="100">
            </el-table-column>
            <el-table-column
              label="Tanım"
              prop="Tanim"
              width="200">
            </el-table-column>
            <el-table-column
              label="Tür"
              prop="Tur"
              width="100">
            </el-table-column>
            <el-table-column
              label="Durum"
              prop="Durum"
              width="100">
            </el-table-column>
            <el-table-column
              label="İşlem Tarihi"
              prop="iTarihi"
              width="150">
            </el-table-column>
            <el-table-column
              label="Dekont Açıklaması"
              prop="Aciklama">
            </el-table-column>
            <el-table-column
              label="Tutar"
              prop="Tutar"
              width="100"
              align="right">
            </el-table-column>
            <el-table-column
              label="Kalan"
              prop="Kalan"
              width="100"
              align="right">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import XLSX from 'xlsx';
  import Yukleniyor from "../../components/Doc/Yukleniyor";

  const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
    name: XLSX.utils.encode_col(i),
    key: i
  }));


  export default {
    components: {Yukleniyor},
    data() {
      return {
        Height: 0,
        lo: false,
        Yetki: false,
        Kaydet: false,
        Sayfa: {
          Adi: 'Banka Ekstresi',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },
        Form: {
          Tarih: [],
          Banka_id: null,
          Tur: "0"
        },
        FormHata: {
          Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tur: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        MakbuzDetayModal: false,
        mNo: null,
        tableData: [],
        ExcelData: [],
        BankaListe: [],
        tableDisplay: false,
        AltToplam: []
      }
    },
    methods: {

      Excel(evt) {

        const ws = XLSX.utils.json_to_sheet(this.ExcelData);
        const wb = XLSX.utils.book_new();
        ws['!cols'] = [
          {wch: 10},
          {wch: 25},
          {wch: 12},
          {wch: 12},
          {wch: 40},
          {wch: 20},
          {wch: 70},
          {wch: 15},
          {wch: 15},
        ];

        wb.Props = {
          Title: this.Sayfa.Adi,
          Author: "Aidatim APP",
          Manager: "Aidatim APP",
          Company: "Aidatim",
          Category: "Finans",
          Keywords: "Aidatim",
          Comments: this.Sayfa.Adi,
        };
        XLSX.utils.book_append_sheet(wb, ws, this.DefterTur);
        XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");
      },
      Yazdir() {
        window.print();
      },
      TableFooter() {
        const sums = [];
        sums[6] = this.AltToplam.ToplamTutar;
        sums[7] = this.AltToplam.ToplamKalan;
        return sums;
      },
      Getir() {
        this.$refs['RaporForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'raporlama/banka/'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.tableData;
                  this.AltToplam = response.AltToplam;
                  this.ExcelData = response.ExcelData;
                  if (this.tableData) this.tableDisplay = true;
                  this.Height = window.innerHeight - 220
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'entegrasyon/banka/'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.BankaListe = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.BankaListe = [];
              this.Form.Banka_id = null;
              this.hata = response.Hata;
            }
          });
      },

    },
    created() {
      this.SayfaYukle();
      var Gun = new Date();
      this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
      this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    },

  }
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/banka.vue